import React from "react";
import QRCode from "qrcode.react";
import withRouter from "../../withRouter";
import { PropTypes } from 'prop-types';
import { frontEndLogs } from "../../action/logs/frontEndLogs";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
import Cookies from "universal-cookie";

export class OBQrcode extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = {
      tokenValue: "",
      greater: false,
      qrScanned: false,
      reGenerateQRCode: false,
      flow:false
    };
  }

  componentDidMount() {
    this.props.handleLoader(false);
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.setState({ tokenValue: this.props.ObToken });
    this.setState({ qrScanned: this.props.qrScanned });
    let applicationId = this.getApplicationIDInstorage();
    if (applicationId !== '' && applicationId != null && applicationId !== undefined) {
      window.dataLayer.push({
        "event": "metadata",
        "applicationID": applicationId
      });
    }
    frontEndLogs('QR is shown in the QR component- ' + applicationId, false, 200, 'componentDidMount');
    analyticsClickEvent('qr_code_shown_in_QR_component', '');
    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') {
      this.setState({flow:true});
    }
  }


  componentDidUpdate(prevProps) {
    if (prevProps.ObToken !== this.props.ObToken) {
      this.setState({ tokenValue: this.props.ObToken });
    }
    if (prevProps.qrScanned !== this.props.qrScanned) {
      this.setState({ qrScanned: this.props.qrScanned });
    }
  }

  resize() {
    if (window.innerWidth <= 680) {
      console.log(window.innerWidth);
      this.setState({ isshowdesktop: false });
    }
  }

  getApplicationIDInstorage() {
    const cookie = new Cookies();
    return sessionStorage.getItem('applicationId') ? sessionStorage.getItem('applicationId') : cookie.get('applicationId')
  }

  regenerateQRcode = () => {
    analyticsClickEvent('re-Generate QRCode enable', '')
    this.setState({ reGenerateQRCode: true });
    // Show the Regenerate QRcode button after the QR code scanner is displayed
    setTimeout(() => {
      this.setState({ reGenerateQRCode: false });
    }, 6000);
  }



  render() {
    if (this.state.qrScanned === true) {
      return (
        <div>
          {this.state.reGenerateQRCode === false &&
            <div className="step-two-section text-center" style={{ fontSize: '15px' }}>
              <button type="button" id="regenerate-btn" className="btn btn-primary regenerate-button" onClick={this.regenerateQRcode}>Regenerate QR Code </button>
            </div>
          }
          {this.state.reGenerateQRCode === true &&
            <div className="QR-align">
              <div style={{ position: 'relative', display: 'inline-block', border: '15px solid #FFFFFF' }}>
                <QRCode size={170} value={`${window.location.origin.toString() + '/ob-verification/' + this.state.tokenValue+'/'+this.state.flow}`} renderAs="svg" bgColor="#FFFFFF" fgColor="#000000" />
                <img src="images/Rectangle.svg"
                  alt="Logo"
                  style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '36px', height: '36px', objectFit: 'contain', backgroundColor: "#FFFFFF", borderRadius: '20%' }}
                />
              </div>
            </div>
          }
        </div>
      );
    } else {
      return (
        <>
          {this.state.tokenValue === '' &&
            <div className="step-two-section text-center btn-qr">
              <button type="button" className="btn btn-primary genrate-qr" onClick={this.generateToken}> QR Code </button>
            </div>
          }
           {console.log(`${window.location.origin.toString() + '/ob-verification/' + this.state.tokenValue+'/'+this.state.flow}`)}
          {this.state.tokenValue !== '' &&
            <div className="QR-align">
              <div style={{ position: 'relative', display: 'inline-block', border: '15px solid #FFFFFF' }}>
                <QRCode size={170} value={`${window.location.origin.toString() + '/ob-verification/' + this.state.tokenValue+'/'+this.state.flow}`} renderAs="svg" bgColor="#FFFFFF" fgColor="#000000" />
                <img src="images/Rectangle.svg"
                  alt="Logo"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '36px',
                    height: '36px',
                    objectFit: 'contain',
                    backgroundColor: "#FFFFFF",
                    borderRadius: '20%'
                  }}
                />
              </div>
            </div>
          }
        </>)
    }
  }
}

OBQrcode.prototypes = {
  handleLoader: PropTypes.func,
  ObToken: PropTypes.string,
  qrScanned: PropTypes.bool,
}
export default withRouter(OBQrcode);
